/**
 * Constantes de l'application (énumérations métier).
 */

export const VISIBILITY_PRIVATE = "private";
export const VISIBILITY_PUBLIC = "public";

export const VISIBILITY_LABELS = {
  private: "Privé",
  public: "Public",
};

export const STATUS_IN_PROGRESS = "in_progress";
export const STATUS_DONE = "done";

export const STATUS_LABELS = {
  in_progress: "En cours",
  done: "Réalisé",
};

export const STAKE_HIGH = "A";
export const STAKE_MEDIUM = "B";
export const STAKE_LOW = "C";

export const STAKE_LABELS = {
  A: "A — Fort",
  B: "B — Moyen",
  C: "C — Faible",
};

export const URGENCY_URGENT = "1";
export const URGENCY_NORMAL = "2";
export const URGENCY_LOW = "3";

export const URGENCY_LABELS = {
  1: "1 — Urgent",
  2: "2 — Normal",
  3: "3 — Peu urgent",
};
